import React, { useState, useEffect } from 'react'
import { Button, Dialog } from '@material-ui/core'
import { COLORES } from '../../../../config/colores'
import { DialogConfirmacionContent } from '../../../Dialogos/DialogConfirmacionContent'
import DialogView from '../../../Dialogos/DialogView'
import ConfirmacionEgresoQRData from '../../components/egresoCalado/ConfirmacionEgresoQRData'
import CallesDeBruto from '../../../Pesado/components/bruto/CallesDeBruto'

function ConfirmacionEgresoQR (props) {
  const { cea, updateCea } = props
  const [showSiloAparte, setShowSiloAparte] = useState(false)
  const [init, setInit] = useState(true)

  useEffect(() => {
    if (!showSiloAparte && cea.caravana === false && init) {
      setShowSiloAparte(true)
      setInit(false)
    }
  }, [showSiloAparte, cea.caravana, init, updateCea])

  const closeAlertSiloAparte = () => { setShowSiloAparte(false) }

  const handleSubmit = (e) => {
    e.preventDefault()
    const { cea } = props
    // handleClose()
    props.updateViewPantallaConfirmacion(true)
    props.egresoQR(cea.ctg)
  }

  const data = [
    {
      nombre: 'Camión',
      value: cea.camion,
      show: true
    },
    {
      nombre: 'Número de CTG',
      value: cea.ctg,
      show: true
    },
    {
      nombre: 'Chofer',
      value: cea.chofer,
      show: true
    },
    {
      nombre: 'Cereal',
      value: cea.cereal,
      show: true
    },
    {
      nombre: 'Cereal Variedad',
      value: cea.cerealVariedad,
      show: cea.cerealVariedad && cea.cerealVariedad.trim() !== 'UNDEF'
    },
    {
      nombre: 'Calificación cereal',
      value: cea.calificacionCereal,
      show: cea && cea.calificacionCereal
    },
    {
      nombre: 'Calificación cereal 2',
      value: cea.calificacionCerealDos,
      show: cea && cea.calificacionCerealDos
    },
    {
      nombre: 'Condición',
      value: cea.condicion,
      show: cea && cea.condicion
    }

  ]

  return (
    <div className='confirmacion-egreso-qr'>

      <Dialog
        open={showSiloAparte}
        onClose={closeAlertSiloAparte}
        fullScreen
      >
        <DialogView
          cancelCallback={closeAlertSiloAparte}
          content={<DialogConfirmacionContent
            message={<p
              style={{
                color: COLORES.warning,
                fontWeight: 'bold',
                fontSize: '1.4rem'
              }}>
                          ATENCIÓN: Descarga silo aparte
            </p>
            }
          />
          }
        />
      </Dialog>

      <div style={{ height: '70vh', display: 'flex', flexDirection: 'column', justifyContent: 'space-around' }}>
        <ConfirmacionEgresoQRData data={data} />
        <div style={{ padding: '8px', backgroundColor: '#c3c3c3', borderRadius: '8px', margibn: '0 10px' }}>
          <h5 style={{ fontWeight: 'bold' }}>Seleccionar calle de bruto</h5>
          <CallesDeBruto onSelected={props.onSelectedCalleBruto} />
        </div>

        <div className='btn-confirmacion-egreso'>
          <Button
            onClick={props.handleClose}
            size='medium'
            color='default'
            variant='outlined'
          >
            Cancelar
          </Button>
          <Button
            type='submit'
            color='primary'
            variant='contained'
            size='medium'
            onClick={handleSubmit}
          >
            Confirmar
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ConfirmacionEgresoQR
